import React, { useRef, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form } from '@unform/web';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';

import { sendEmailRequest } from 'store/modules/resetpassword/actions';

import { FiMail } from 'react-icons/fi';

import logo from 'assets/logo.png';

import Button from 'components/Button';
import Input from 'components/Input';
import MessageBox from 'components/MessageBox';

import { Container } from './styles';

const schema = Yup.object().shape({
  email: Yup.string()
    .email('Insira um e-mail válido')
    .matches('rpc.com.br', 'Insira um e-mail válido')
    .required('Campo Obrigatório'),
});

export default function ForgotPassword() {
  // react-router-dom
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const formRef = useRef();

  const resetpassword = useSelector(state => state.resetpassword);

  const handleSubmit = useCallback(
    async ({ email }) => {
      try {
        // Remove all previous errors
        formRef.current.setErrors({});
        await schema.validate(
          { email },
          {
            abortEarly: false,
          },
        );
        dispatch(sendEmailRequest(email));
      } catch (err) {
        const validationErrors = {};
        if (err instanceof Yup.ValidationError) {
          err.inner.forEach(error => {
            validationErrors[error.path] = error.message;
          });
          formRef.current.setErrors(validationErrors);
        }
      }
    },
    [dispatch],
  );

  return (
    <Container>
      <img src={logo} alt="RPC" />
      <Form ref={formRef} onSubmit={handleSubmit} autoComplete="off">
        {!resetpassword.success && (
          <h5>Você receberá um email com instruções:</h5>
        )}

        {!!resetpassword.success && (
          <MessageBox type="success">{resetpassword.success}</MessageBox>
        )}

        {!resetpassword.success && (
          <>
            <Input
              name="email"
              type="text"
              placeholder="Email"
              icon={<FiMail />}
            />
            <Button
              fill="false"
              color="primary"
              type="submit"
              disabled={resetpassword.loading}
            >
              {resetpassword.loading ? 'AGUARDE ...' : 'RECUPERAR SENHA'}
            </Button>
          </>
        )}

        <Button fill color="primary" onClick={() => navigate('/')}>
          VOLTAR
        </Button>
      </Form>
    </Container>
  );
}
